import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MomentModule } from "ngx-moment";

import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { PopoverModule } from "ngx-bootstrap/popover";

import {
  CodeManagementIndexComponent,
  LanguagePackIndexComponent,
  ReportIndexComponent,
  FMIProductIndexComponent,
  SurveyIndexComponent,
  FMIProductListComponent,
  SurveyListComponent,
  PMDocumentIndexComponent,
  PMDocumentListComponent,
  PMUserIndexComponent,
  PMUserListComponent,
  PartsManualIndexComponent,
  PartsManualListComponent,
  AdministrationRouting,
} from "./index";
import { SharedModule } from "./../shared/shared.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
// Angular Material modules needed for refactored FMIProductListComponent table
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  imports: [
    CommonModule,
    MomentModule,
    PaginationModule.forRoot(),
    FormsModule,

    SharedModule,

    AdministrationRouting,

    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    PdfViewerModule,
    MatTableModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
  declarations: [
    CodeManagementIndexComponent,
    LanguagePackIndexComponent,
    ReportIndexComponent,
    FMIProductIndexComponent,
    SurveyIndexComponent,
    FMIProductListComponent,
    SurveyListComponent,
    PMDocumentIndexComponent,
    PMDocumentListComponent,
    PMUserIndexComponent,
    PMUserListComponent,
    PartsManualIndexComponent,
    PartsManualListComponent,
  ],
})
export class AdministrationModule {}
